import { Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

/**
 * Section heading in the settings panel — sentence case, ~14px, soft gray
 * (e.g. "How should we bring it in?"), matching the pdf.to.design look.
 */
export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <Text
      mb="2.5"
      fontSize="md"
      fontWeight="500"
      color="figma.textSecondary"
      letterSpacing="snug"
    >
      {children}
    </Text>
  );
}
